import React, { useState } from "react";
import PropTypes from "prop-types";
import ContactHelper from "../../../../entities/contact/contact-helper";
import Modal from "../../../../shared/components/dashboard-layout/components/modal/modalComponent";

const DeleteContactModal = ({ show, onHide, contact, onContactDeleted }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleClose = () => {
        setIsLoading(false);
        setError(null);
        onHide();
    };

    const handleDelete = async () => {
        if (!contact?.id) return;
        setIsLoading(true);
        setError(null);
        try {
            await ContactHelper.deleteContact(contact.id);
            onContactDeleted();
            handleClose();
        } catch (err) {
            setError(
                err?.response?.data?.message ||
                "Failed to delete contact. Please try again."
            );
        }
        setIsLoading(false);
    };

    if (!show) return null;

    return (
        <Modal
            isVisible={show}
            onClose={() => {
                if (isLoading) return;
                handleClose();
            }}
            header={"Delete Contact"}
            className={"delete-contact-modal"}
            cancelButtonLabel={"Close"}
            cancelButtonAction={() => {
                if (isLoading) return;
                handleClose();
            }}
            negativeButtonLabel={isLoading ? "Deleting..." : "Delete"}
            negativeButtonAction={() => {
                if (isLoading) return;
                handleDelete();
            }}
        >
            {error && <div className="alert alert-danger mb-3">{error}</div>}
            <div className="confirmation-content">
                <p className="confirmation-message">
                    Are you sure you want to delete the contact <strong>{contact?.name}</strong>?
                </p>
                <p className="warning-text">This action cannot be undone.</p>
            </div>
        </Modal>
    );
};

DeleteContactModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    contact: PropTypes.object,
    onContactDeleted: PropTypes.func.isRequired,
};

export default DeleteContactModal;